
import { ArrowRight, GraduationCap } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import AnimatedBackground from './AnimatedBackground';
import CapabilitiesCard from './CapabilitiesCard';
import PriceDisplay from './PriceDisplay';

const NetworkSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [counterValue, setCounterValue] = useState(999);
  const [showFinalPrice, setShowFinalPrice] = useState(false);
  const [showGraduationCap, setShowGraduationCap] = useState(false);
  const isMobile = useIsMobile();

  const adminCapabilities = [
    "System Updates & Patch Management",
    "Monitoring & Performance Optimization",
    "Security Management",
    "Software Installation & Troubleshooting",
    "Hardware & Infrastructure Troubleshooting"
  ];

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 500);
    const capTimer = setTimeout(() => setShowGraduationCap(true), 1500);
    return () => {
      clearTimeout(timer);
      clearTimeout(capTimer);
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      const countdown = setInterval(() => {
        setCounterValue(prev => {
          if (prev <= 0) {
            clearInterval(countdown);
            setShowFinalPrice(true);
            return 0;
          }
          return prev - Math.floor(Math.random() * 50) - 10;
        });
      }, 100);
      
      return () => clearInterval(countdown);
    }
  }, [isVisible]);

  return (
    <section className="py-20 bg-nexx-dark text-white relative overflow-hidden grid-overlay section-pulse">
      <AnimatedBackground />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            Frankly we have the{' '}
            <span className="text-nexx-green font-bold animate-pulse relative inline-block">
              greatest minds
              {showGraduationCap && !isMobile && (
                <GraduationCap 
                  className="absolute -top-8 left-1/2 transform -translate-x-1/2 text-nexx-green w-8 h-8 animate-bounce"
                  style={{
                    animation: 'fall-and-bounce 2s ease-out forwards'
                  }}
                />
              )}
            </span>
            {' '}in the business.
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            And we don't charge you a{' '}
            <span className="text-nexx-green font-bold animate-pulse">
              dime extra
            </span>
            .
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center justify-center gap-8">
            <CapabilitiesCard 
              capabilities={adminCapabilities}
              isVisible={isVisible}
            />

            {/* Single Large Bouncing Arrow - Hidden on Mobile */}
            {!isMobile && (
              <div className="flex items-center justify-center relative">
                <ArrowRight className="h-24 w-24 text-nexx-green animate-bounce" />
              </div>
            )}

            <PriceDisplay 
              counterValue={counterValue}
              showFinalPrice={showFinalPrice}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NetworkSection;
